export default [{
    path: '/kanban',
    name: 'kanban',
    component: () => import('@/views/modules/Kanban/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [{
        text: 'navbars.kanban',
        active: true,
      }, ],
      action: 'read',
      resource: 'sales',
      unique_name: "kanban"
    },
  },
  {
    path: '/kanban/:id',
    name: 'kanban',
    component: () => import('@/views/modules/Kanban/LidDatail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [{
          text: 'navbars.kanban',
          active: true,
        },
        {
          text: 'navbars.kanban_details',
          active: true,
        },
      ],
      action: 'read',
      resource: 'sales',
      unique_name: "kanban"
    },
  },

]